import { Post, PostTopic } from "../../types/post";
import dayjs from "dayjs";
import { usePostsContext } from "../../Provider/context";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "~/components/ui/card";
import { AspectRatio } from "~/components/ui/aspect-ratio";
import { Text } from "~/components/ui/text";
import { createMemo, Show } from "solid-js";
import { htmlToReadableText } from "~/util/dom";
import { Button } from "~/components/ui/button";
import { Icon } from "~/components/ui/icon";
import { mdiChevronRight } from "@mdi/js";
import { Group } from "~/components/ui/group";
import { Badge } from "~/components/ui/badge";

interface Props {
	post: Post;
	onClickPost?: (id: string) => void;
}

export function PostCard(props: Props) {
	const { select, topics } = usePostsContext();

	const onSelectPost = () => {
		select(props.post.id);
		props?.onClickPost?.(props.post.id);
	};

	const topic = createMemo<PostTopic | undefined>(() => {
		const allTopics = topics();
		
		if (allTopics.length > 0) {
			return props.post.topic || {
				id: "rest",
				name: "Overig",
			}
		}
	});

	return (
		<Card class="flex flex-col min-h-[493px]">
			<CardHeader>
				<AspectRatio ratio={16 / 9}>
					<img
						class="size-full rounded-md object-cover"
						src={props.post.bannerUrl}
						alt={props.post.title}
					/>
				</AspectRatio>
			</CardHeader>
			<CardContent class="flex flex-col h-full flex-1">
				<Group class="min-h-[56px]" justify="between">
					<div>
						<CardTitle class="font-semibold line-clamp-2 mb-2">
							{props.post.title}
						</CardTitle>
						<CardDescription>
							{dayjs(props.post.publishedAt).format("dddd D MMMM YYYY")}
						</CardDescription>
					</div>
					<Show when={topic()}>
						{(currentTopic) => (
							<Badge class="ml-auto self-start" variant="filled">
								{currentTopic().name}
							</Badge>
						)}
					</Show>
				</Group>
				<Show when={props.post.summary || htmlToReadableText(props.post.content) || true}>
					{(content) => (
						<Text class="line-clamp-3 w-full mt-4 min-h-[72px] prose">
							{content()}
						</Text>
					)}
				</Show>
				<Button
					class="w-full mt-auto"
					onClick={onSelectPost}
					variant="light"
				>
					Lees meer
					<Icon path={mdiChevronRight} class="ml-auto" />
				</Button>
			</CardContent>
		</Card >
	);
}